import { useState } from 'react';

import { Alert, Button, Dialog, DialogTitle, DialogActions, DialogContent } from '@mui/material';

import { useTranslate } from 'src/locales';

import ApplicationProfileResumeUploader from 'src/components/profile-importer/applicant-resume-importer';

type Props = {
  applicationId: string;
  open: boolean;
  onClose: VoidFunction;
};

export default function ApplicationProfileImporterDialog({ applicationId, open, onClose }: Props) {
  const { t } = useTranslate();

  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleClose = () => {
    setErrorMessage(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle>{t('applications.candidate_resume_importer.modal.title')}</DialogTitle>
      <DialogContent>
        {errorMessage && (
          <Alert sx={{ mb: 2 }} severity="error">
            {errorMessage}
          </Alert>
        )}
        <ApplicationProfileResumeUploader
          applicationId={applicationId}
          showWarning
          onSuccess={handleClose}
          onError={setErrorMessage}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t('common.cancel')}</Button>
      </DialogActions>
    </Dialog>
  );
}
